import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

/**
 * `/services`: the old address of every Services screen (`?tab=Songs&song=…`),
 * kept so links in emails, bookmarks and PraiseCharts' return still land.
 * Each screen has its own address now; this sends each old one there.
 */
export const Route = createFileRoute('/_authed/_shell/services/')({
  validateSearch: z.object({
    tab: z.enum(['Plans', 'Songs', 'Teams', 'Schedule']).optional(),
    song: z.uuid().optional(),
    arrangement: z.uuid().optional(),
    // `all` was every service's plans at once, since retired: it lands on Plans.
    type: z.uuid().optional().catch(undefined),
    praisecharts: z.enum(['linked', 'failed']).optional(),
  }),
  beforeLoad: ({ search }) => {
    if (search.song && search.arrangement)
      throw redirect({
        to: '/services/songs/$songId/arrangements/$arrangementId',
        params: { songId: search.song, arrangementId: search.arrangement },
        replace: true,
      })
    if (search.song)
      throw redirect({
        to: '/services/songs/$songId',
        params: { songId: search.song },
        replace: true,
      })
    if (search.tab === 'Songs')
      throw redirect({
        to: '/services/songs',
        search: search.praisecharts ? { praisecharts: search.praisecharts } : {},
        replace: true,
      })
    // Teams has gone (docs/14): its tab is People now; /services/teams decides who has it.
    if (search.tab === 'Teams') throw redirect({ to: '/services/teams', replace: true })
    if (search.tab === 'Schedule') throw redirect({ to: '/services/schedule', replace: true })
    if (search.type)
      throw redirect({
        to: '/services/types/$typeId',
        params: { typeId: search.type },
        replace: true,
      })
    throw redirect({ to: '/services/plans', replace: true })
  },
})
